/* Zeger van Olden — storefront helpers. */

/* 1. Indicative currency switcher in the header — euro and US dollar only */
(function(){
var C={EUR:['€',50],USD:['$',50]};
var FB={EUR:1,USD:1.15115};
var K='zvo-cur',R=null;
function g(n){return String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'.');}
function eur(el){if(el.dataset.eur)return +el.dataset.eur;var t=el.textContent.replace(/[^0-9.,]/g,'');if(!t)return null;t=t.replace(/\./g,'').replace(',','.');var v=parseFloat(t);if(isNaN(v))return null;el.dataset.eur=v;return v;}
function draw(c){var cf=C[c],r=(R&&R[c])||FB[c]||1;
document.querySelectorAll('.card__price,.product__price').forEach(function(el){var e=eur(el);if(e===null)return;
if(c==='EUR'){el.textContent='€'+g(Math.round(e));return;}
var v=Math.round(e*r/cf[1])*cf[1];el.textContent=cf[0]+g(v)+' '+c;});
var n=document.getElementById('zvo-note');if(n){n.style.display=(c==='EUR')?'none':'';}}
function init(){var host=document.querySelector('.site-header__tools')||document.querySelector('.site-header__nav');if(!host||document.getElementById('zvo-sel')){return;}
var s=document.createElement('select');s.id='zvo-sel';s.className='zvo-cur';s.setAttribute('aria-label','Show prices in another currency');
Object.keys(C).forEach(function(k){var o=document.createElement('option');o.value=k;o.textContent=k;s.appendChild(o);});
var cur='EUR';try{cur=localStorage.getItem(K)||'EUR';}catch(e){}
if(!C[cur]){cur='EUR';}
s.value=cur;
s.addEventListener('change',function(){try{localStorage.setItem(K,s.value);}catch(e){}draw(s.value);});
host.insertBefore(s,host.firstChild);
var n=document.createElement('p');n.id='zvo-note';n.className='zvo-note';n.textContent='Prices in US dollars are indicative. Orders are charged in euro.';n.style.display='none';
var m=document.querySelector('main')||document.body;m.insertBefore(n,m.firstChild);
draw(cur);
fetch('https://open.er-api.com/v6/latest/EUR').then(function(x){return x.json();}).then(function(j){if(j&&j.rates){R=j.rates;draw(document.getElementById('zvo-sel').value);}}).catch(function(){});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

/* 2. Header: hairline once scrolled, and its height exposed as
   --zvo-header-h so the sticky product details sit just below it. */
(function(){
function run(){
var h=document.querySelector('.site-header-wrap');if(!h)return;
function size(){document.documentElement.style.setProperty('--zvo-header-h',(getComputedStyle(h).position==='sticky'?h.offsetHeight:0)+'px');}
function f(){h.classList.toggle('is-scrolled',window.scrollY>4);}
size();f();
window.addEventListener('scroll',f,{passive:true});
window.addEventListener('resize',size);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();
